<template>
  <NavigationDesktop class="hidden lg:block" :nav="nav" :meta="meta" />
  <NavigationMobile class="lg:hidden" :nav="nav" :meta="meta" />
</template>

<script setup>
defineProps({
  nav: { type: Object, required: true },
  meta: { type: Object, required: true },
})
</script>
